define("media/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "media/config/environment", "media/resolver"], function (_exports, _engine, _emberLoadInitializers, _environment, _resolver) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/engine",0,"ember-load-initializers",0,"media/config/environment",0,"media/resolver"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const {
    modulePrefix
  } = _environment.default;
  class Eng extends _engine.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "modulePrefix", modulePrefix);
      _defineProperty(this, "Resolver", _resolver.default);
      _defineProperty(this, "dependencies", {
        services: ['alerts', 'auth', 'cache', 'credential-status', 'credentials', 'dialogManager', 'dropbox', 'errors', 'events', 'intl', 'locale', 'mediaItemQuery', 'mediaItemUpload', 'mediaLabels', 'mediaLibrary', 'mediaNavigation', 'mediaUpload', 'perfectScroll', 'queryPersistence', 'router', 'selected-social-profiles', 'schedule/caption-hashtags', 'seamless-checkout-manager', 'secondaryModal', 'segment', 'starredMedia', 'store', 'subscriptions', 'uploadBus', 'userConfig'],
        externalRoutes: ['calendarMedia', 'contribute', 'schedule', 'account.groups', 'cluster.media']
      });
    }
  }
  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = _exports.default = Eng;
});